
const About = () => {

    return(
        <div className="error-page">
            <h1>About</h1>
        </div>
    )
}

export default About;